import * as React from 'react'
import classNames from 'classnames'

import { cardImgSizes } from 'ui-component-library/utils/imgSizes'

import { ArticleSource } from 'ui-component-library/components/00-Primitives/ArticleLink'
import type { Image, LinkType } from 'types'

import ArticleLink from 'ui-component-library/components/00-Primitives/ArticleLink'
import CategoryLinks from './CategoryLinks'
import CommentToggleButton from 'ui-component-library/components/CommentToggleButton'
// import FeaturedDailyHeader from '../FeaturedDailyModule/FeaturedDailyHeader'
import Link from 'content-components/_Primatives/Link'
import Paragraph from 'content-components/_Primatives/Paragraph'
import { InlineImage } from 'content-components/_Primatives/Images'
import { useMediaQuery } from 'ui-component-library/components/MediaQuery'

import style from './style.scss'

export type Categories = {
  categoryLinks: Array<LinkType>
  publishedText: string
}

export type Props = {
  allowModal?: boolean
  articleSource: ArticleSource
  bodyText?: string
  className?: string
  commentLabelText: string
  commentsCount?: number
  commentsUrl: string
  headlineText: string
  image: Image
  isDaily?: boolean
  isGradient?: boolean
  isModal?: boolean
  link: LinkType
  publishedCategories?: Categories
  publishedDateText?: string
  topicId: string
}

ArticleSummary.defaultProps = {
  allowModal: false,
  className: '',
  isDaily: false,
  isGradient: false,
  // isModal: false,
  publishedCategories: undefined,
  publishedDateText: '',
}

function ArticleSummary(props: Props) {
  const {
    allowModal,
    articleSource,
    bodyText,
    className,
    headlineText,
    image,
    isDaily,
    isGradient,
    isModal,
    link,
    publishedCategories,
    publishedDateText,
    // topicId,
    commentsCount,
    commentLabelText,
    commentsUrl,
  } = props
  const { text: linkText, url, isVideo } = link
  const linkProps = { articleSource, isVideo, url }

  const { belowTablet } = useMediaQuery({ tablet: true })

  const photoNode =
    allowModal && isModal ? (
      <span aria-hidden className={style.image}>
        <InlineImage
          gradient={isGradient}
          image={image}
          isModal
          sizes={cardImgSizes}
        />
      </span>
    ) : (
      <Link aria-hidden className={style.image} url={url}>
        <InlineImage gradient={isGradient} image={image} sizes={cardImgSizes} />
      </Link>
    )

  const hasDailyTabletView = belowTablet && isDaily

  return (
    <article
      aria-label={headlineText}
      className={classNames(style.wrapper, className)}
    >
      {!hasDailyTabletView && photoNode}
      <div className={style.articleContent}>
        {publishedDateText && (
          <div>
            <span className={style.publishedDate}>{publishedDateText}</span>
          </div>
        )}
        <div className={style.articleContentHeader}>
          <Link className={style.headlineLink} url={url}>
            <h2 className={style.headlineText}>{headlineText}</h2>
          </Link>
          <CommentToggleButton
            className={style.commentsButton}
            topicText={headlineText}
            count={commentsCount}
            labelText={commentLabelText}
            url={commentsUrl}
          />
        </div>
        {hasDailyTabletView && photoNode}
        {bodyText && (
          <Paragraph className={style.articleExcerpt}>{bodyText}</Paragraph>
        )}
        <ArticleLink {...linkProps}>
          {linkText}
          <span className={style.hideLinkText}>{headlineText}</span>
        </ArticleLink>
        {publishedCategories && <CategoryLinks {...publishedCategories} />}
      </div>
    </article>
  )
}

export default ArticleSummary
